import { css } from '@emotion/react/macro'
import { primaryTextColor } from './colors'
import { tertiaryBodyCss } from './typography'

export const tableCss = css`
  border-collapse: collapse;
  border-spacing: 0;
  margin-bottom: 0;
  width: 100%;
`

export const tableCellCss = css`
  padding: 16px;
  line-height: 72px;
  ${tertiaryBodyCss}
  color: ${primaryTextColor};
`
